// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__PBPxs","content":"LayoutSettings_content__28aV4"};